import {createAction} from "redux-act";

export const showBRSponsorModal = createAction();
export const hideBRSponsorModal = createAction();
